import { Link } from 'react-router-dom'
import React from 'react'
import { useQuery } from '../utils'

import { Context } from '../store/Store'
import { Oval } from 'react-loader-spinner'
import Subtitle from '../components/Subtitle'
import Title from '../components/Title'
import axios from 'axios'

export function StocksList() {
  const query = useQuery()
  const success = query.get('success')

  const { app } = React.useContext(Context)
  const [loading, setLoading] = React.useState(true)
  const [stocks, setStocks] = React.useState([])
  const [, setApiError] = React.useState(false)
  const [, setAvailableLegumes] = React.useState([])

  // Fonction pour obtenir les détails d'un légume à partir de son ID
  const getLegumeDetails = (legumeId) => {
    if (!app.legumes || !Array.isArray(app.legumes)) return null;
    return app.legumes.find(legume => legume.id === legumeId);
  };

  // Fonction pour obtenir la valeur maximale pour un légume
  const getLegumeMax = (legumeId) => {
    if (!app.legumes_nomenclature_stock || !Array.isArray(app.legumes_nomenclature_stock)) return null;
    const nomenclature = app.legumes_nomenclature_stock.find(item => item.legume && item.legume.id === legumeId);
    return nomenclature ? nomenclature.max : null;
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';

    let date;
    // The backend might send 'DD/MM/YYYY' or 'YYYY-MM-DD'. We need to handle both.
    if (dateString.includes('/')) {
      const parts = dateString.split('/');
      if (parts.length === 3) {
        // It's likely DD/MM/YYYY. new Date(year, monthIndex, day) is local timezone.
        // To be safe, we construct a UTC date string.
        const isoDate = `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
        date = new Date(isoDate);
      } else {
        return dateString; // Invalid format
      }
    } else {
      // Assumes YYYY-MM-DD or other ISO formats.
      // new Date() will correctly parse this as UTC.
      date = new Date(dateString);
    }

    if (isNaN(date.getTime())) {
      return dateString; // Return original string if date is invalid
    }

    // Format the date in French, ensuring we use UTC to avoid timezone-related day shifts.
    return new Intl.DateTimeFormat('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'UTC',
    }).format(date);
  };

  React.useEffect(() => {
    // Charger la liste des stocks
    axios
      .get(
        `${
          process.env.REACT_APP_APOLLO_URL || 'https://extranet.biobreizh.org'
        }/wp-json/bb/v1/stocks/${app.profil ? app.profil.id : 'default'}`
      )
      .then(function (response) {
        if (response.status === 200) {
          const stocksData = response.data.stocks || [];
          setStocks(stocksData);

          // Calculer les légumes disponibles pour ajout (non présents dans le stock)
          if (Array.isArray(app.legumes) && stocksData.length > 0) {
            // Extraire tous les IDs de légumes déjà présents dans le stock
            const stockLegumeIds = new Set();
            stocksData.forEach(stock => {
              if (stock.items && Array.isArray(stock.items)) {
                stock.items.forEach(item => {
                  if (item.legume_id) {
                    stockLegumeIds.add(item.legume_id.ID || item.legume_id);
                  }
                });
              }
            });

            // Filtrer les légumes disponibles (non présents dans le stock)
            const availableLegumesArray = app.legumes.filter(legume =>
              !stockLegumeIds.has(legume.id)
            );
            setAvailableLegumes(availableLegumesArray);
          } else {
            setAvailableLegumes(app.legumes || []);
          }

          setApiError(false);
          setLoading(false);
        }
      })
      .catch(function (error) {
        console.log(error)
        setApiError(true)
        setLoading(false)

        // En mode développement, afficher des données fictives
        if (process.env.NODE_ENV === 'development') {
          const mockStocks = [
            {
              id: 'mock1',
              date: new Date().toISOString(),
              items: [
                { legume_id: 'l1', legume_nom: 'Carotte', quantite: '10', unite: 'kg' },
                { legume_id: 'l2', legume_nom: 'Pomme de terre', quantite: '15', unite: 'kg' }
              ]
            },
            {
              id: 'mock2',
              date: new Date(Date.now() - 86400000).toISOString(), // Hier
              items: [
                { legume_id: 'l3', legume_nom: 'Tomate', quantite: '5', unite: 'kg' }
              ]
            }
          ];
          setStocks(mockStocks);
        }
      })
  }, [app.profil])

  return (
    <div className="max-w-7xl mx-auto px-6">
      <div className="w-full py-5 border-gray-200">
        <Subtitle title="Module Stock" />
        <Title title="Liste des déclarations" />
{/*
        {apiError && (
          <div className="rounded-md bg-price-light/20 p-4 mb-6">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-price" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-price-dark">Mode démo activé</h3>
                <div className="mt-2 text-sm text-price">
                  <p>Le serveur API n'est pas accessible. Les données affichées sont fictives.</p>
                </div>
              </div>
            </div>
          </div>
        )} */}

        {success === 'create' && (
          <div className="rounded-md bg-price-light/20 p-4 my-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg
                  className="h-5 w-5 text-price"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div className="ml-3">
                <p className="text-sm font-medium text-price-dark">
                  Déclaration de stock enregistrée avec succès
                </p>
              </div>
            </div>
          </div>
        )}

        <div className="flex justify-between my-4">
          <Link
            to="/stocks/status"
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
              <path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" />
            </svg>
            État des stocks
          </Link>
        </div>

        {loading ? (
          <div className="flex justify-center items-center h-64">
            <Oval color="#0F5F3F" height={40} width={40} />
            <span className="ml-2">Chargement...</span>
          </div>
        ) : stocks.length === 0 ? (
          <div className="bg-white shadow overflow-hidden sm:rounded-md p-6 text-center">
            <p className="text-gray-500">Aucune déclaration de stock trouvée</p>
          </div>
        ) : (
          <div className="bg-white shadow overflow-hidden sm:rounded-md">
            <ul className="divide-y divide-gray-200">
              {stocks.map((stock) => (
                <li key={stock.id}>
                  <div className="px-4 py-4 sm:px-6">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        <p className="text-sm font-medium text-price truncate">
                          Déclaration du {formatDate(stock.date)}
                        </p>
                      </div>
                    </div>
                    <div className="mt-2 sm:flex sm:justify-between">
                      <div className="sm:flex">
                        <div className="flex flex-col items-start text-sm text-gray-500">
                          {stock.items.map((item, index) => (
                            <span key={index} className="mr-2">
                              {item.legume_nom}: {item.quantite} {getLegumeDetails(item.legume_id)?.unite || item.unite}
                              {getLegumeMax(item.legume_id) && (
                                <span className="text-xs text-gray-400 ml-1">
                                  (Max: {getLegumeMax(item.legume_id)})
                                </span>
                              )}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  )
}

export default StocksList
